import React from 'react';
import { Link } from 'react-router-dom';
import '../style/components/_formationCards.scss';

const FormationCard = ({ formation }) => {
    return (
        <div className="formation-card">
            <Link to={formation.link}>
                <div className="formation-card_content" style={{ backgroundImage: `url(${formation.img})` }}>

                    <div className="formation-card_overlay">
                        <p className="formation-card_description">{formation.cardDescription}</p>

                        <div>
                            <h3 className="formation-card_title">{formation.title}</h3>
                            <h4 className="formation-card_subtitle">{formation.subtitle}</h4>
                        </div>
                    </div>
                </div>
            </Link>
        </div>
    );
};

const FormationCards = ({ formations }) => {
    return (
        <div className="formation-cards_container">
            {formations.map((formation) => (
                <FormationCard
                    key={formation.id}
                    formation={formation}
                />
            ))}
        </div>
    );
};

export default FormationCards;